<template>
  <div class="renderHome">
    <div class="template-header">
      <div
        class="template-title"
        :style="
          'background: #fff url(' + headerBg + ') no-repeat bottom; background-size: 100% auto;'
        "
        :class="{ 'active': -1 == editorIndex }"
      >
        <div class="current-active" />
        <span>{{ homeConfig && homeConfig.title || '设置页面信息' }}</span>
      </div>
    </div>
    <div
      class="template-view"
      :style="cssStyle"
    >
      <div class="template">
        <div
          class="components-container"
          :style="formPageCssStyle"
        >
          <div v-if="relStore.id != '0' && element_edit_status == 2">
            <div
              v-for="(item, index) in platformComponents"
              :key="index"
              class="component-item"
            >
              <component
                :is="item.name"
                :key="index"
                class=""
                :res="item"
              />
            </div>
          </div>
          <draggable
            v-model="components"
            :options="dragViewOptions"
            class="components-wrap"
            data-id-attr="data-id"
            @end="onEnd"
            @add="onAdd"
          >
            <div
              v-for="(item, index) in components"
              :key="item.id"
              class="component-item"
              @click="setCurrent(index, 'homeSet')"
            >
              <div>
                <transition name="el-fade-in-linear">
                  <div
                    v-if="editorIndex === index"
                    class="iconfont icon-trash-alt"
                    @click="removeCurrent"
                  />
                </transition>
                <!-- 'component-padded': item.data.padded,  -->
                <div
                  class="component-wrap"
                  :class="{ 'active': index == editorIndex }"
                >
                  <component
                    :is="item.name"
                    v-if="item.id"
                    :id="item.id"
                    :key="item.id"
                    :comp__this="item"
                    :res="item"
                    :base-config="formItemConfig"
                    :active="index == editorIndex"
                  />
                </div>
              </div>
            </div>
          </draggable>
        </div>
      </div>
      <div
        style="position: relative; width: 98%; left: 1%"
        :class="{ 'active': -2 == editorIndex }"
      >
        <div class="current-active" />
        <div
          v-if="pedestalConfig.type === 'formTmps'"
          class="subButton"
          :style="subButtonCssStyle"
        >
          {{ subButtonConfig && subButtonConfig.buttonTitle }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// api
import mixin from '@/view/weappTmp/core/mixin/index'
import register from '@/view/weappTmp/core/mixin/register'
import TmpStore from '@/view/weappTmp/core/lib/base/store.js'
import { CSSTransition } from '@/view/weappTmp/core/lib/public/css.js'
import { keyMap } from '@/view/weappTmp/core/lib/public/homePageConfig.js'
import { getRandwords } from '@/utils'
import { initData } from '@/view/weappTmp/core/mixin/registerConfig.js'
import {CompsNode} from '@/view/weappTmp/core/lib/package/comps-node.js'
const headerBg = require('@/assets/img/weappTmp/renderHomeTitle.png')
// 第三方组件
export default {
  name: 'RenderHome',
  mixins: [mixin, register],
  props: {
    parent_components: {
      type: Array,
      default: () => {
        return []
      }
    },
    pedestalConfig: {
      type: Object
    },
    customConfigMap:{
      type: Object
    }
  },
  data () {
    return {
      platformComponents: [],
      components: [],
      componentsMap: {},
      element_edit_status: null,
      dragViewOptions: {
        group: {
          name: 'easyview',
          put: (evt) => {
            // console.log('renderHome-group:evt',evt)
            return true
          }
        },
        animation: 300,
        forceFallback: false,
        scroll: true
      },
      cssStyle: {},
      homeConfig: {},
      formPageConfig: {},
      formPageCssStyle: {},
      formItemConfig: {},
      formItemCssStyle: {},
      subButtonConfig: {
        title: '提交按钮'
      },
      subButtonCssStyle: {},
      headerBg: headerBg
    }
  },
  watch: {
    components: {
      handler: function (nv, ov) {
        TmpStore.setVal('components', nv)
        // console.log('components-TmpStore',TmpStore)
        // console.log('功能组件模版View', nv)
      },
      deep: true
    },
    customConfigMap:{
      handler: function (nv, ov) {
        console.log('renderHome-customConfigMap',nv)
        this.updateHomeConfig(nv)
      },
      deep: true
    }
  },  
  created () {
    this.init()
  },
  mounted () {
    // console.log('RenderHome-end')
    this.callEcho()
  },
  methods: {
    consoleLog (...arg) {
      console.log(...arg)
    },
    // init
    init () {
      const that = this
      TmpStore.setVal('editorIndex', 0)
      
      this.updateHomeConfig(TmpStore.getVal('customConfigMap')||{})
      // TmpStore.$on('homeConfig', () => {
      //   const homeConfigs = TmpStore.getVal('homeConfig')
      //   const { homeConfig, formProtocolConfig, formPageConfig, subButtonConfig, formItemConfig } =
      //     homeConfigs
      //   that.$set(this, 'cssStyle', CSSTransition(homeConfig))
      //   that.$set(this, 'homeConfig', homeConfig)
      //   // console.log('cssStyle', CSSTransition(homeConfig))
      //   that.$set(this, 'formPageCssStyle', CSSTransition(formPageConfig))
      //   that.$set(this, 'formPageConfig', formPageConfig)
      //   console.log('formPageCssStyle', CSSTransition(formPageConfig))

      //   that.$set(this, 'subButtonConfig', subButtonConfig)
      //   that.$set(this, 'subButtonCssStyle', CSSTransition(subButtonConfig))
      //   that.$set(this, 'formItemConfig', formItemConfig)
      //   that.$set(this, 'formItemCssStyle', CSSTransition(formItemConfig))
      // })
    },
    // 回显;
    callEcho () {
      this.components = this.parent_components
      const findTmpMap = initData[this.pedestalConfig.type]
      const TmpList = []
      this.components.length &&
        this.components.forEach((d) => {
          const td = findTmpMap[d.name]
          if (td && !d.props) {
            d = Object.assign(JSON.parse(JSON.stringify(td)), d)
          }
          d = new CompsNode(d)          
        })
    },
    getRenderHomeData () {
      const { platformComponents, components } = this
      const data = []
      components.forEach((d) => {
        data.push(d.subDataFormat())
      })
      return {
        data
      }
    },
    // 改变home
    updateHomeConfig (data) {
      const configData = {}
        const that = this
        const customs = Object.values(data)
        if(customs.length){
          customs.forEach(custom=>{
            for(let k in custom.data){
              configData[keyMap[k]] = configData[keyMap[k]] || {}
              configData[keyMap[k]][k] = custom.data[k]
            }
          })          
          console.log('configData',configData)
          const { homeConfig  ,formPageConfig ,subButtonConfig ,formItemConfig } = configData
          that.$set(this, 'cssStyle', CSSTransition(homeConfig))
          that.$set(this, 'homeConfig', homeConfig)
          that.$set(this, 'formPageCssStyle', CSSTransition(formPageConfig))
          that.$set(this, 'formPageConfig', formPageConfig) 
          that.$set(this, 'subButtonConfig', subButtonConfig)
          that.$set(this, 'subButtonCssStyle', CSSTransition(subButtonConfig))
          that.$set(this, 'formItemConfig', formItemConfig)
          that.$set(this, 'formItemCssStyle', CSSTransition(formItemConfig))
        }
    },
    onEnd (evt) {
      this.setCurrent(evt.newIndex, 'onEnd')
    },
    onAdd (evt) {
      // console.log('renderHome-add',evt)
      // console.log('renderHome-add初始化组件')
    },
    // 删除当前组件
    removeCurrent () {
      this.$confirm('确认删除当前组件？')
        .then((_) => {
          // console.log('removeCurrent-change-editorData',this.editorData)
          this.editorData = {}
          // console.log('removeCurrent-change-editorIndex',this.editorIndex)
          const delTarget = this.components[this.editorIndex]
          TmpStore.$off(delTarget.id)
          this.components.splice(this.editorIndex, 1)
          this.setCurrent(null)
        })
        .catch((_) => {})
    }
  }
}
</script>

<style lang="scss">
@import '../../../index';
.renderHome {
  width: 318px;
  height: 690px;
  margin: 0;
  margin-left: 20px;
  .template {
    border-top: 1px solid rgba(0, 0, 0, 0);
  }
  .template-header {
    background: #fff;
    width: 98%;
    margin-left: 1%;
    .template-title {
      position: relative;
      width: 100%;
      height: 70px;
      margin: 0 auto;
      text-align: center;
      line-height: 70px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #111111;
      font-size: 14px;
      span {
        display: inline-block;
        padding-top: 12px;
      }
    }
  }
  // width:375px;
  .template-title {
    cursor: pointer;
  }
  .template-view {
    margin: 0;
    width: 100%;
    height: 620px;
    position: relative;

    .template {
      // margin-right: -20px;
    }
  }
  .subButton {
    margin-top: 15px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    background: #fff;
    cursor: pointer;
    position: relative;
    width: 90%;
    margin-left: 5%;
  }
}
.components-container {
  // position: relative;
  // padding-right: 20px;
  // padding-top: 5px;
  // max-width:322px;
  // width: 100%;
  height: 550px;
  // background: rgb(240, 242, 245);
  overflow-y: overlay;
  // height: calc(100vh - 170px);
  // margin-left: 5px;
  padding-bottom: 20px;
  .components-wrap {
    min-height: 510px;
    width: 100%;
    // overflow: hidden;
    &.edit {
      padding-top: 0px;
      padding-bottom: 69px;
    }
  }
  &.componentFixed {
    padding-top: 58.5px;
  }
  &.is-distributor {
    padding-top: 40px;
  }
  &.componentFixed.is-distributor {
    padding-top: 98.5px;
  }
  .component-item {
    position: relative;
    padding: 0 5px;
    .icon-trash-alt {
      position: absolute;
      right: 10px;
      color: #ff5000;
      cursor: pointer;
      z-index: 1999;
    }
  }
  .component-wrap {
    position: relative;
    width: 100%;
    margin: 0 auto;
    cursor: pointer;
    // background: #fff;
    &.component-padded {
      // padding: 10px 0;
      width: 100%;
    }
    .current-active {
      position: absolute;
      left: -3px;
      top: -3px;
      right: -3px;
      bottom: -3px;
      border: 3px solid #ff5000;
      z-index: -1;
      opacity: 0;
      box-shadow: 0 0 5px rgba(255, 80, 0, 0.3);
      background: rgba(255, 80, 0, 0.2);
      transition: all 0.3s ease;
    }
    &.active .current-active {
      opacity: 1;
      z-index: 999;
    }
    .component-header {
      display: flex;
      align-items: center;
      .component-title {
        display: flex;
        align-items: flex-end;
        flex: 1;
        font-size: 14px;
        min-width: 80px;
        &.middle {
          align-items: center;
        }
        .subtitle {
          padding-left: 5px;
          font-size: 12px;
          color: #999;
        }
      }
      .component-more {
        display: flex;
        justify-content: center;
        width: 25px;
        .three-dot {
          position: relative;
          width: 4px;
          height: 4px;
          background: #333;
          border-radius: 50%;
          &::before,
          &::after {
            position: absolute;
            width: 4px;
            height: 4px;
            background: #333;
            border-radius: 50%;
            content: '';
          }
          &::before {
            transform: translateX(-160%);
          }
          &::after {
            transform: translateX(160%);
          }
        }
      }
    }
    .component-body {
      &.with-padding {
        // padding: 0 10px;
      }
    }
  }
}
</style>
